import HotelCard from './HotelCard'
import { PAGE_SIZE } from './hotelUtils'

export default function SearchPanel({ hotels, page, selected, onSelect, onPage }) {
  const totalPages = Math.max(1, Math.ceil(hotels.length / PAGE_SIZE))
  const safePage = Math.min(page, totalPages)
  const start = (safePage - 1) * PAGE_SIZE
  const slice = hotels.slice(start, start + PAGE_SIZE)

  return (
    <div className="hotelSearchView">
      <div className="hotelSearchGrid">
        {slice.map((hotel) => (
          <HotelCard
            key={hotel.id}
            hotel={hotel}
            selected={selected?.id === hotel.id}
            onSelect={onSelect}
          />
        ))}
        {!slice.length ? <p className="hotelEmpty">No properties match these filters.</p> : null}
      </div>
      {hotels.length > PAGE_SIZE ? (
        <div className="hotelPager">
          <button type="button" disabled={safePage <= 1} onClick={() => onPage(safePage - 1)}>Previous</button>
          <span>Page {safePage} of {totalPages} ({hotels.length} hotels)</span>
          <button type="button" disabled={safePage >= totalPages} onClick={() => onPage(safePage + 1)}>Next</button>
        </div>
      ) : null}
    </div>
  )
}
